import { css, cx } from "@emotion/css";
import { ReactElement, ReactNode } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { Theme } from "@/modules/theme/utils/createTheme";

import { Typography } from "./Typography/Typography";

type FullScreenNotificationBoxProps = {
  title?: string;
  text?: string | ReactElement;
  children?: ReactNode;
  className?: string;
  textClassName?: string;
};

export function FullScreenNotificationBox({
  title,
  text,
  className,
  textClassName,
  children,
}: FullScreenNotificationBoxProps) {
  const classes = createStyles(useTheme());
  return (
    <div className={cx(classes.root, className)}>
      {title && <Typography variant="pageHeading">{title}</Typography>}
      {text && (
        <Typography
          variant="contentLarge"
          className={cx(classes.text, textClassName)}
        >
          {text}
        </Typography>
      )}
      {children}
    </div>
  );
}

function createStyles({ spacing }: Theme) {
  return {
    root: css({
      textAlign: "center",
      paddingBottom: spacing(5),
    }),
    text: css({
      padding: spacing([2, 2, 4, 2]),
      maxWidth: 260,
    }),
  };
}
